export default __webpack_public_path__ + "static/media/Nav-News active.916c9275.svg";